/**
 * Pure IAP disabled-reason vocabulary + copy (push9 / v1.4.3-b9).
 *
 * Split out of iap.ts so it can be unit-tested without importing the
 * RevenueCat SDK or the queryClient (which drags in @tanstack/react-query and
 * the whole network stack). iap.ts re-exports both symbols, so callers keep
 * importing from "./iap" unchanged.
 */

// Why IAP is disabled, or null when purchases are healthy.
export type IapDisabledReason =
  | "web_platform"
  | "plugin_missing"
  | "missing_key"
  | "configure_failed"
  | null;

/**
 * Map a disabled reason to a trainer-facing one-liner. Pure: no SDK, no DOM,
 * no network — safe to unit-test in isolation.
 */
export function describeDisabledReason(reason: IapDisabledReason): string {
  switch (reason) {
    case "web_platform":
      return "Web preview, purchases run in the iOS / Android build only.";
    case "plugin_missing":
      return "RevenueCat plugin not registered, rebuild with `npx cap sync ios`.";
    case "missing_key":
      return "VITE_REVENUECAT_PUBLIC_KEY not set at build time, IAP disabled.";
    case "configure_failed":
      return "RevenueCat.configure() failed. Check the public key value / network.";
    case null:
      return "Purchases available.";
  }
}
